import { useEffect, useMemo } from 'react';
import { InputProps } from '@antimatterhq/ui/components/input';
import { useFormikContext } from 'formik';
import cronstrue from 'cronstrue';
import { FormInput, FormMessage } from '../form';
import { useCheckFormikError } from '@/hooks/formik/useCheckFormikError';

export type FormCronInputProps = {
  name: string;
  value: string;
} & InputProps;

export const FormCronInput = ({
  value,
  disabled,
  name,
  onChange,
  ...props
}: FormCronInputProps) => {
  const { error } = useCheckFormikError({ name });
  const { validateField, handleBlur } = useFormikContext();

  const schedule = useMemo(() => {
    if (!value) {
      return '';
    }

    try {
      return cronstrue.toString(value);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      return '';
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    setTimeout(() => {
      handleBlur({ target: { name } });
      validateField(name);
    }, 1);
  };

  useEffect(() => {
    if (!disabled) {
      handleBlur({ target: { name } });
      validateField(name);
    }
  }, [disabled, handleBlur, validateField, name]);

  return (
    <div className="w-full max-w-3xl space-y-2">
      <div className="flex items-center gap-4">
        <div className="relative w-[200px]">
          <FormInput
            name={name}
            placeholder="0 0 * * * ?"
            value={value}
            disabled={disabled}
            onChange={handleChange}
            data-testid={`form-cron-input-${name}`}
            {...props}
          />
          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
            {!!error && !disabled && (
              <FormMessage type="error" hideIcon className="text-sm">
                Invalid
              </FormMessage>
            )}
            {!!value && !error && !disabled && (
              <span className="text-sm text-green-600 dark:text-green-500">
                Valid
              </span>
            )}
          </div>
        </div>
        {!!schedule && !error && (
          <p className="text-sm text-grey-500 dark:text-grey-350">
            Runs {schedule.toLowerCase()}
          </p>
        )}
      </div>
    </div>
  );
};
